import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

// import Dashboard from './Dashboard.vue'
import Files from '../files/Files'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/dashboard/:id?',
      name: 'dashboard',
      components: {
        default: Files,
        // default: Dashboard,
        header: AppHeader
      },
      meta: {
        title: 'videos'
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
